const memberCostMethods = {
  hourly: { id: 'hourly', name: 'Hourly Wage' },
  fixed_hourly: { id: 'fixed_hourly', name: 'Fixed Wage Per-Hour' },
  fixed_monthly: { id: 'fixed_monthly', name: 'Fixed Wage Per-Month' },
};

export default memberCostMethods;
